import { ICellRendererComp, ICellRendererParams } from 'ag-grid-community';
import { IntlShape } from 'react-intl';
import './styles.scss';

export interface CustomSelectParams extends ICellRendererParams {
    intl: IntlShape;
    icon: string;
    hide: boolean;
    disabled?: (data: any) => boolean;
    onClick: (data: any) => void;
}

export class TableButtonRenderer implements ICellRendererComp {
    eGui!: HTMLDivElement;
    params: any;
    disabled?: boolean;
    onClick!: (data: object) => void;

    init(params: CustomSelectParams) {
        this.params = params;
        this.onClick = params.onClick;
        this.disabled = params.disabled && params.disabled(params.data);
        this.eGui = document.createElement('div');
        this.eGui.classList.add('tsr-icon-renderer', 'normal');
        this.eGui.style.cursor = this.disabled ? 'not-allowed' : 'pointer';
        this.disabled ? this.eGui.classList.add('disabled') : this.eGui.classList.remove('disabled');
        this.eGui.innerHTML = params.icon;
        this.btnClickedHandler = this.btnClickedHandler.bind(this);
        this.eGui.addEventListener('click', this.btnClickedHandler);

        if (params.hide) {
            this.eGui = document.createElement('div');
            this.eGui.hidden = true;
        }
    }
    getGui() {
        return this.eGui;
    }

    btnClickedHandler = () => {
        this.params.onClick && !this.disabled && this.params.onClick(this.params.data);
    };

    refresh(params: CustomSelectParams) {
        this.eGui.style.cursor = params.disabled && params.disabled(params.data) ? 'not-allowed' : 'pointer';
        params.disabled && params.disabled(params.data)
            ? this.eGui.classList.add('disabled')
            : this.eGui.classList.remove('disabled');
        return true;
    }
}
